'use strict';

function once(fn) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      fn.apply(null, arguments);
    }
  };
}

module.exports = once;



//////////////////
// WEBPACK FOOTER
// ./~/@braintree/wrap-promise/lib/once.js
// module id = 647
// module chunks = 0